export const LABELS = {
  heading: 'Where do you live?',
  subHeading: 'To get started, select your property (type min. 6 characters to search)',
};
